import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

const { section, favourites } = routes;

/**
 * The section item-list area's route tree: every leaf renders the same page, which already
 * branches on whether a category id is present. Favourites are the same list over a different
 * set of entries, so they live here rather than in a feature tree of their own.
 */
export const sectionRoutes: RouteRender[] = [
  lazyView(section.items, () => import("./sections").then((m) => ({ default: m.SectionItemsPage })), ""),
  lazyView(section.categoryItems, () => import("./sections").then((m) => ({ default: m.SectionItemsPage })), ""),
  lazyView(favourites, () => import("./sections").then((m) => ({ default: m.FavouriteItemsPage })), "Favourites"),
];
